module.exports = __webpack_public_path__ + "img/HongJianTou.de038c60.svg";